import React from 'react';
import MenuScreen from './main';
import Header from './internalCommons/header';
import {createOrderScreens} from '../constants/internalScreens';

const ManageOrders = () => {
  return (
    <>
      <Header screen={createOrderScreens.main} />
      <MenuScreen />
    </>
  );
};

export default ManageOrders;
